import { createApp } from 'vue';
import CardSliderBlock from './cardSliderBlock.vue';
import store from 'shared/store';

const elements = document.querySelectorAll('[data-feature="CardSliderBlock"]');
if (elements.length) {
	elements.forEach((element, i) => {
		const app = createApp({
			name: `CardSliderBlockApp${i}`,
		});
		app.component('card-slider-block', CardSliderBlock);
		app.use(store);
		app.mount(element);
	});
}
